import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitClassicPublicRoute: InvariantJiraRoute = {
	name: 'software-form-submit-classic-public',
	path: '/jira/software/c/form/:formUuid',
	exact: true,
};
